"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ethers_1 = require("ethers");
var zod_1 = require("zod");
var errors_1 = require("../errors");
var utils_1 = require("../utils");
var InputSchema = zod_1.z.union([
    zod_1.z.tuple([]),
    zod_1.z.tuple([
        zod_1.z.string().refine(function (salt) { return ethers_1.ethers.utils.isHexString(salt, 32); }, { message: "Invalid salt" }),
    ]),
]);
/**
 * @dev Requests cardano address from injected cardano provider and transforms it to the Actor address
 */
var eth_requestAccounts = function (provider_1, _a) { return __awaiter(void 0, [provider_1, _a], void 0, function (provider, _b) {
    var cardanoProvider, actorFactoryAddress, salt, address, e_1;
    var params = _b.params;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                cardanoProvider = provider.cardanoProvider, actorFactoryAddress = provider.actorFactoryAddress;
                if (actorFactoryAddress === undefined) {
                    throw new errors_1.ProviderRpcError("Actor factory address not set. Run setup() first.", errors_1.JSON_RPC_ERROR_CODES.DISCONNECTED);
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 4, , 5]);
                salt = InputSchema.parse(params)[0];
                return [4 /*yield*/, cardanoProvider.getChangeAddress()];
            case 2:
                address = _c.sent();
                return [4 /*yield*/, (0, utils_1.getActorAddress)(provider, address, salt)];
            case 3: 
            // const bech32Address = Address.from_bytes(Buffer.from(address, "hex")).to_bech32();
            return [2 /*return*/, [_c.sent()]];
            case 4:
                e_1 = _c.sent();
                if (e_1 instanceof zod_1.ZodError) {
                    throw new errors_1.ProviderRpcError("Invalid input", errors_1.JSON_RPC_ERROR_CODES.INVALID_PARAMS, e_1);
                }
                throw new errors_1.ProviderRpcError("Failed to get accounts", errors_1.JSON_RPC_ERROR_CODES.INTERNAL_ERROR, e_1);
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.default = eth_requestAccounts;
